export default __webpack_public_path__ + "static/media/dashboard-reports.89dd5b3d.svg";